import type { VNode } from "preact";
import type { SortKey, HealthFilter } from "../types";

type Props = {
  query: string;
  onQuery: (q: string) => void;
  filter: HealthFilter;
  onFilter: (f: HealthFilter) => void;
  sort: SortKey;
  onSort: (s: SortKey) => void;
  onlyRss: boolean;
  onOnlyRss: (b: boolean) => void;
  count: number;
};

const SORT_LABELS: Record<SortKey, string> = {
  effective: "Effective",
  score: "Score",
  ping_avg: "Ping",
  samples: "Samples",
  domain: "Domain",
  updated: "Updated",
};

export function Toolbar({
  query,
  onQuery,
  filter,
  onFilter,
  sort,
  onSort,
  onlyRss,
  onOnlyRss,
  count,
}: Props): VNode {
  return (
    <div class="toolbar">
      <div class="search">
        <input
          type="search"
          placeholder="Filter instances…"
          value={query}
          onInput={(e) => onQuery((e.target as HTMLInputElement).value)}
        />
      </div>

      <div class="segmented" role="group" aria-label="Filter by health">
        {(["all", "healthy", "unhealthy"] as HealthFilter[]).map((f) => (
          <button
            type="button"
            aria-pressed={filter === f}
            onClick={() => onFilter(f)}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      <label
        style="display: inline-flex; align-items: center; gap: 6px; font-size: 13px; color: var(--fg-muted); cursor: pointer;"
      >
        <input
          type="checkbox"
          checked={onlyRss}
          onChange={(e) => onOnlyRss((e.target as HTMLInputElement).checked)}
        />
        RSS only
      </label>

      <select
        class="select"
        value={sort}
        onChange={(e) => onSort((e.target as HTMLSelectElement).value as SortKey)}
      >
        {Object.entries(SORT_LABELS).map(([k, v]) => (
          <option value={k}>Sort: {v}</option>
        ))}
      </select>

      <span class="muted" style="font-size: 13px; font-variant-numeric: tabular-nums;">
        {count} shown
      </span>
    </div>
  );
}
